import { render, staticRenderFns } from "./ReservationDetailPageLoader.vue?vue&type=template&id=1824138e"
import script from "./ReservationDetailPageLoader.vue?vue&type=script&lang=js"
export * from "./ReservationDetailPageLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports